"use client";

import styles from "./index.module.css";

interface AudioWaveIconProps {
  isPlaying?: boolean;
  size?: number;
  className?: string;
  color?: string;
}

export function AudioWaveIcon({
  isPlaying = false,
  size = 36,
  className = "",
  color = "#AFAFF8",
}: AudioWaveIconProps) {
  return (
    <svg
      className={`${className} ${isPlaying ? styles.playing : ""}`}
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 62 62"
      fill="none"
    >
      {/* 中心最高的柱子 */}
      <rect
        className={styles.bar1}
        x="28.13"
        y="5.17"
        width="5.74"
        height="51.66"
        rx="2.87"
        fill={color}
      />

      {/* 左右两边中等高度的柱子 */}
      <rect
        className={styles.bar2}
        x="16.65"
        y="12.82"
        width="5.74"
        height="36.36"
        rx="2.87"
        fill={color}
      />
      <rect
        className={styles.bar3}
        x="39.61"
        y="12.82"
        width="5.74"
        height="36.36"
        rx="2.87"
        fill={color}
      />

      {/* 最外侧较矮的柱子 */}
      <rect
        className={styles.bar4}
        x="5.17"
        y="24.30"
        width="5.74"
        height="13.40"
        rx="2.87"
        fill={color}
      />
      <rect
        className={styles.bar5}
        x="51.09"
        y="24.30"
        width="5.74"
        height="13.40"
        rx="2.87"
        fill={color}
      />
    </svg>
  );
}
